import { render, staticRenderFns } from "./BackToTop.vue?vue&type=template&id=514a24c0&scoped=true"
import script from "./BackToTop.vue?vue&type=script&lang=js"
export * from "./BackToTop.vue?vue&type=script&lang=js"
import style0 from "./BackToTop.vue?vue&type=style&index=0&id=514a24c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514a24c0",
  null
  
)

export default component.exports